<template>
  <div id='index' v-if="body_show" class="vb_img">
    <!-- 公用头部 -->
    <public-header :routArg="routArg" :headimg="headImg"></public-header>
    <img src="@a/images/gsb1.png" alt="" />
    <img src="@a/images/gsb2.png" alt="" />
    <img src="@a/images/gsb3.png" alt="" />
    <img src="@a/images/gsb4.png" alt="" />
    <img src="@a/images/gsb5.png" alt="" />
    <img src="@a/images/gsb6.png" alt="" />
    <img src="@a/images/gsb7.png" alt="" />
    <img src="@a/images/gsb8.png" alt="" />
    <img src="@a/images/gsb9.png" alt="" />
    <img src="@a/images/gsb10.png" alt="" />
    <img src="@a/images/gsb11.png" alt="" />
    <img src="@a/images/gsb12.png" alt="" />
    <a class="sign_item detail_new_1" @click="signHandle"></a>
    <img src="@a/images/gsb14.png" alt="" />
    <img src="@a/images/gsb15.png" alt="" />
    <img src="@a/images/gsb16.png" alt="" />
    <img src="@a/images/gsb17.png" alt="" />
    <img src="@a/images/gsb18.png" alt="" />
    <img src="@a/images/gsb19.png" alt="" />
    <img src="@a/images/gsb20.png" alt="" />
    <img src="@a/images/gsb21.png" alt="" />
    <img src="@a/images/gsb22.png" alt="" />
    <img src="@a/images/gsb23.png" alt="" />
    <img src="@a/images/gsb24.png" alt="" />
    <a class="sign_item detail_new_2" @click="signHandle"></a>
    <img src="@a/images/gsb26.png" alt="" />
    <img src="@a/images/gsb27.png" alt="" />
    <img src="@a/images/gsb28.png" alt="" />
    <img src="@a/images/gsb29.png" alt="" />
    <img src="@a/images/gsb30.png" alt="" />
    <img src="@a/images/gsb31.png" alt="" />
    <img src="@a/images/gsb32.png" alt="" />
    <img src="@a/images/gsb33.png" alt="" />
    <img src="@a/images/gsb34.png" alt="" />
    <img src="@a/images/gsb35.png" alt="" />
    <img src="@a/images/gsb36.png" alt="" />
    <a class="sign_item detail_new_3" @click="signHandle"></a>
    <img src="@a/images/gsb39.png" alt="" />
    <a href="https://www.jianshu.com/p/164b9d734ed4" class="detail_new_article"><img src="@a/images/gsb40.png" alt="" /></a>
    <img src="@a/images/gsb41.png" alt="" />
    <a href="https://www.jianshu.com/p/56f332e15740" class="detail_new_article"><img src="@a/images/gsb42.png" alt="" /></a>
    <img src="@a/images/gsb43.png" alt="" />
    <a href="https://www.jianshu.com/p/cb5166a52fbb" class="detail_new_article"><img src="@a/images/gsb44.png" alt="" /></a>
    <img src="@a/images/gsb45.png" alt="" />
    <a href="https://mp.weixin.qq.com/s/St6G9zQx5F7iu16_vbHodw" class="detail_new_article"><img src="@a/images/gsb46.png" alt="" /></a>

    <img src="@a/images/gsb47.png" alt="" />
    <a href="https://mp.weixin.qq.com/s/oQTlJHJ-4RKNCrzReKWZZQ" class="detail_new_article"><img src="@a/images/gsb48.png" alt="" /></a>

    <img src="@a/images/gsb49.png" alt="" />
    <a href="https://www.jianshu.com/p/bbbcc85a958a" class="detail_new_article"><img src="@a/images/gsb50.png" alt="" /></a>

    <img src="@a/images/gsb51.png" alt="" />
    <a href="https://www.jianshu.com/p/cd490dd27a24" class="detail_new_article"><img src="@a/images/gsb52.png" alt="" /></a>

    <img src="@a/images/gsb53.png" alt="" />
    <a class="sign_item detail_new_4" @click="signHandle"></a>
    <img src="@a/images/gsb55.png" alt="" />
    <!-- 验证手机号和付款 -->
    <public-mobile ref="handle" :cid="cid" :source="source" :type="'course'" :pdk="pdk" :aspx="aspx"></public-mobile>
    <public-ewm :assistant_show="assistant_show" :ewm_img="ewm_img"></public-ewm>
  </div>
</template>
<script>
import { statistics } from "@/api/public";
import { coursedetail } from "@/api/course"
import { project_click_time } from "@/api/course"
import { statistic_next } from "@/api/course"
import { shareCon } from "@/utils/wxconfig";
import { getStorage, setStorage } from "@/utils/tools"
let xx = require("../../../assets/carrer.png");
export default {
  data() {
      return {
        pblname: "pl",
        name: "",
        music: "",
        body_show: false,
        cid: null,
        headImg: "",
        data: {},
        phone: null,
        source: '',
        pdk: '',
        aspx: '',
        assistant_show: false,
        ewm_img: "",
        routArg: {}
      }
    },
    methods: {
      pullData() {
        coursedetail({
            bid: this.$route.query.bid
          })
          .then((data) => {
            this.ewm_img = xx;
            this.body_show = true;
            this.data = data;
            this.cid = String(data.id);
            if (!data.subscribe && data.qrcode.length > 0) {
              this.assistant_show = true;
              this.ewm_img = data.qrcode;
            };
            this.source = this.$route.query.source || '';
            // 分享
            this.pdk = this.$route.query.pdk || '';
            this.aspx = this.$route.query.aspx || '';
            if(this.source){
              this.routArg['source'] = this.source;
            }
            if(this.pdk){
              this.routArg['pdk'] = this.pdk;
            }
            if(this.aspx){
              this.routArg['aspx'] = this.aspx;
            }
            // 用户图像
            this.headImg = data.userdetail.headimgurl;
            shareCon("course",this);
            // 神策统计
            sensors.track('courseDetails', {
              classification: data.bigcoursename,
              classification_id: this.$route.query.bid,
              channel_name: this.source || '',
              course_id: this.cid,
              course_name: data.coursename,
              share_user_id: this.pdk || '',
              course_discount_price: data.courseprice,
              course_original_price: data.originalprice,
              course_starttime: data.begintime,
              // 新增
              course_user_type: data.ishavedbuy ? "已付费" : "未付费"
            })
          })
      },
      // 立即报名
      signHandle() {
        this.statistical("coursebtn");
        // 神策统计--点击立即报名按钮
        sensors.track('applyCourse', {
          apply_page_url: location.href,
          apply_page_title: this.data.bigcoursename,
          classification: this.data.bigcoursename,
          classification_id: this.$route.query.bid,
          course_id: this.cid,
          course_name: this.data.coursename,
          course_discount_price: this.data.courseprice,
          course_original_price: this.data.originalprice,
          course_starttime: this.data.begintime
        });
        // 把神策数据存到本地缓存
        let godPolicy = {
          course_id: this.cid,
          classification: this.data.bigcoursename,
          course_name: this.data.coursename,
          course_discount_price: this.data.courseprice,
          course_original_price: this.data.originalprice,
          course_starttime: this.data.begintime
        };
        setStorage('godPolicy', 'godPolicy', godPolicy);
        if (this.data.mobilestatus) {
          // 是否需要验证验证码
          this.$refs.handle.need_verify = this.data.need_verify || false;
          // 判断用户手机号是否已验证
          this.$refs.handle.phone = this.data.userdetail.mobile ? this.data.userdetail.mobile : null;
          this.$refs.handle.show = true;
        } else {
          this.$refs.handle.pay()
        }
      },
      // 本地统计
      statistical(data) {
        statistics({
          type: data
        }).then();
      },
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.vb_img {
  width: 100%;
  img {
    width: 100%
  }
  a.sign_item {
    width: 750px;
    height: 124px;
    display: block;
    background: url(../../../assets/images/gsb13.png) no-repeat top center;
    background-size: cover;
  }
}
</style>
